(function(){
"use strict";

angular.module("swapick")
.factory('Districts', Districts);

function Districts(DataService, $q){

  let svc = {};
  svc.districts=null;

  svc.loadDistricts = () => {
    return DataService.districts.get()
    .then(districts => {
      svc.districts = districts;
      return districts;
    })
  }

  svc.getDistricts = () =>  (svc.districts === null ? svc.loadDistricts() : $q.when(svc.districts))

  svc.getDistrictByName = districtName  => {
    return svc.getDistricts()
    .then(districts => {
      return _.find(districts, item => {
        return item.nome && item.nome.toLowerCase() == districtName.toLowerCase()
      })
    })
  }

  return svc;
}



})();



// WEBPACK FOOTER //
// ./src/services/districts-service.js